//import * as Sentry from '@sentry/react';

/**
 * This function is used to log if the response from the CMS is blank or empty.
 * It is used to log the error to Sentry.
 * @param data - The data to check if it is blank or empty.
 * @returns void
 */
export const logIfEmptyCMSResponse = (data: any) => {
  const isBlankOrEmpty =
    !data || (typeof data === 'object' && Object.keys(data).length === 0);

  if (isBlankOrEmpty) {
    // Sentry.captureException(
    //   new Error('Critical error: Blank or empty response from CMS')
    // );
    console.log('Critical error: Blank or empty response from CMS');
  }
};
